import { DocumentGenerationStep } from '@sharefiledev/doc-gen-pilet-sdk';
import { StateCreator } from 'zustand';
import { storeResetFns } from '.';

type SignatureRequest = {
	currentStep: DocumentGenerationStep | null;
	drawerCloseType: string;
	isEditInProgress: boolean;
	numberOfsteps: number;
	isMergingDocument: boolean;
	hasMergedDocumentFile: boolean;
};

type State = {
	signatureMetadata: SignatureRequest;
};

type Actions = {
	updateSignatureMetadata: (data: Partial<SignatureRequest> | SignatureRequest) => void;
};

export type SignatureRequestState = State & Actions;

const initialState = {
	signatureMetadata: {
		currentStep: null,
		drawerCloseType: '',
		isEditInProgress: false,
		numberOfsteps: 2,
		isMergingDocument: false,
		hasMergedDocumentFile: false,
	},
};

export const createSignatureRequestSlice: StateCreator<SignatureRequestState> = (
	set,
	get
) => {
	storeResetFns.add(() => {
		set(initialState);
	});

	return {
		...initialState,
		updateSignatureMetadata: (data: Partial<SignatureRequest> | SignatureRequest) => {
			const { signatureMetadata } = get();

			set({
				signatureMetadata: { ...signatureMetadata, ...data },
			});
		},
	};
};
